import { FeatureContentElementKey, FeatureContentVersions, FeatureContentVersionType } from '../feature-versioning'

/**
 * Relevant for users who have not saved any content version in the database yet. (e.g. new users)
 * Gets the initial content version to store in database and marks elements/content as new if key is added to the parameter list.
 */
export const getInitialContentVersionAndMarkElementsAsNew = (elementKeysMarkedAsNew: FeatureContentElementKey[]): FeatureContentVersionType => {
  const initialFeatureContentVersion: FeatureContentVersionType = { ...FeatureContentVersions }
  elementKeysMarkedAsNew.forEach(featureKey => {
    initialFeatureContentVersion[featureKey] = initialFeatureContentVersion[featureKey] - 1
  })
  return initialFeatureContentVersion
}
